<script setup lang="ts">
import ToastContainer from '~/components/toast/ToastContainer.vue';
import TabBarNavigate from '~/modules/tabBar/components/TabBarNavigate.vue';
import TeleportContainer from '~/components/app/TeleportContainer.vue';

import constructPageClass from '~/utils/constructPageClass';

import { useWebsiteStore } from '~/stores/websiteStore';
import { useInitTabBar } from '~/uses/useInitTabBar';
import { useSiteMedia } from '~/uses/useSiteMedia';

const route = useRoute();
useSiteMedia();
useInitTabBar();
const websiteStore = useWebsiteStore();

const pageClass = ref<string>('');

pageClass.value = constructPageClass(route.path);

watch(() => route.path, (newVal) => {
  pageClass.value = constructPageClass(newVal);
});

const classes = computed(() => ({
  'page_hidden': websiteStore.pageHiddenPoint,
  'page_visible': !websiteStore.pageHiddenPoint,
  'page_disable-fade': websiteStore.disablePageAnimation,
  'page_hydration-processing': !websiteStore.hydrationComplete,
}));

/**
 * Имена задаются в defineOptions каждой страницы
 */
const keepAlivePatterns = [
  'IndexPage',
  'FavoritePage',
  'MenuCatalogMobile',
  'ProductPages',
  // 'SearchPage', // закомментировал, т.к. есть проблемы с замудрённым useSearchParamsSubscriber
  'CatalogCategoryPages',
  'CatalogIndexPage',
  'CatalogSalesPage',
  'OrdersIndexPage',
  'OrderDetailPage',
  'CartPage',
];

// useRuntimeHook('app:created', () => {
//   console.log('app:created');
// });
// useRuntimeHook('app:beforeMount', () => {
//   console.log('app:beforeMount');
// });
// useRuntimeHook('app:mounted', () => {
//   console.log('app:mounted');
// });
// useRuntimeHook('app:rendered', () => {
//   console.log('app:rendered');
// });
// useRuntimeHook('app:redirected', () => {
//   console.log('app:redirected');
// });
// useRuntimeHook('app:suspense:resolve', () => {
//   console.log('app:suspense:resolve');
// });
// useRuntimeHook('app:error', (e: any) => {
//   console.log('app:error', e);
// });
// useRuntimeHook('app:error:cleared', () => {
//   console.log('app:error:cleared');
// });
// useRuntimeHook('app:chunkError', () => {
//   console.log('app:chunkError');
// });
// useRuntimeHook('app:data:refresh', () => {
//   console.log('app:data:refresh');
// });
// useRuntimeHook('app:manifest:update', () => {
//   console.log('app:manifest:update');
// });
// useRuntimeHook('dev:ssr-logs', () => {
//   console.log('dev:ssr-logs');
// });
// useRuntimeHook('link:prefetch', () => {
//   console.log('link:prefetch');
// });
// useRuntimeHook('page:start', () => {
//   console.log('page:start');
// });
// useRuntimeHook('page:finish', () => {
//   console.log('page:finish');
// });
// useRuntimeHook('page:transition:finish', () => {
//   console.log('page:transition:finish');
// });
// useRuntimeHook('page:view-transition:start', () => {
//   console.log('page:view-transition');
// });
// useRuntimeHook('page:loading:start', () => {
//   console.log('page:loading:start');
// });
// useRuntimeHook('page:loading:end', () => {
//   console.log('page:loading:end');
// });
// useRuntimeHook('vue:setup', () => {
//   console.log('vue:setup');
// });
// useRuntimeHook('vue:error', (e: any) => {
//   console.log('vue:error', e);
// });
</script>

<template>
  <div id="site" class="page" :class="classes">
    <VitePwaManifest/>

    <NuxtLayout>
      <NuxtPage :keepalive="{ include: keepAlivePatterns }"/>
    </NuxtLayout>

    <ClientOnly>
      <TabBarNavigate
        v-if="websiteStore.isSecondaryLayout"
        :block="websiteStore.blockTabBar"
      />
      <ToastContainer/>
    </ClientOnly>

    <TeleportContainer/>
  </div>
</template>

<style lang="scss">
body {
  // Для PWA
  padding-top: env(safe-area-inset-top, 0);
  padding-right: env(safe-area-inset-right, 0);
  padding-left: env(safe-area-inset-left, 0);
  // Для webApp
  background: #ffffff;
  // Улучшение рендеринга на iOS
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  -webkit-font-smoothing: antialiased;
}

body .page {
  padding-right: var(--scrollbar-gap, 0px);

  &:not(.page_hydration-processing) {

    &.page_hidden:not(.page_disable-fade) {
      main, footer {
        @media ($media-tablet) {
          opacity: 0;
          user-select: none;
          pointer-events: none;
          transition: opacity 0.050s ease-in;
        }
      }
    }

    &.page_visible:not(.page_disable-fade) {
      main, footer {
        @media ($media-tablet) {
          opacity: 1;
          user-select: auto;
          pointer-events: auto;
          transition: opacity 0.150s ease-in;
        }
      }
    }
  }

  &.page_hydration-processing {
    ._page-hidden-processing {
      @media ($media-tablet) {
        opacity: 0;
        user-select: none;
        pointer-events: none;
        transition: opacity 0.010s ease-in;
      }
    }
  }
}
</style>
